"use client"; // Error components must be Client Components
import {
  ErrorDisplay,
  type ErrorDisplayProps,
} from "@shared-components/error-display";

export default function Error(props: ErrorDisplayProps) {
  return <ErrorDisplay {...props} />;
}
